import Image from "next/image";
import { Box, Center, Flex, HStack, Stack, Highlight } from "@chakra-ui/react";
import visionImg from "public/about-us/our-vision.jpg";
import missionImg from "public/about-us/our-mission.png";
import TickImage from "public/shared/check-box.png";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import { VISION_CONSTANTS } from "./constants";

const VisionComp = () => {
  const { title, desc } = VISION_CONSTANTS;
  const HeadingVarinat = useHeadingVariant();
  const TextVariant = useTextVariant();
  const Comp1 = VISION_CONSTANTS.points[0];
  const Comp2 = VISION_CONSTANTS.points[1];
  return (
    <Box mt={-12}>
      <Flex gap={6} direction={"column"}>
        <Heading as="h2" variant={HeadingVarinat} textAlign={"center"}>
          {title}
        </Heading>
        <Text variant={TextVariant} color="text.100" textAlign={"center"}>
          {desc}
        </Text>
        <Flex
          direction={{ base: "column-reverse", md: "row" }}
          gap={{ base: 2, md: 20 }}
          mb={8}
          borderRadius={"12px"}
          backgroundColor={"gray.100"}
        >
          <Center flex={1.25} p={{ base: 4, md: 8 }}>
            <Stack gap={4} mt={2}>
              <Text variant={"label1"} fontWeight={600}>
                {Comp1.title}
              </Text>
              {Comp1.desc.map((item, descIndex) => (
                <Text key={descIndex} variant={TextVariant} color="text.100">
                  <Highlight
                    styles={{ fontWeight: 700, color: "text.100" }}
                    query={item.highlight}
                  >
                    {item.text}
                  </Highlight>
                </Text>
              ))}
              <Stack gap={1}>
                {Comp1.list &&
                  Comp1.list.map((item, listIndex) => (
                    <HStack
                      key={listIndex}
                      gap={1.5}
                      align={"flex-start"}
                      justify={"center"}
                    >
                      <Image
                        alt={title}
                        src={TickImage}
                        style={{ height: "auto", width: "20px", paddingTop: "4px" }}
                        loading="lazy"
                      />
                      <Box key={listIndex}>
                        <Text
                          as="span"
                          variant={TextVariant}
                          fontWeight="600"
                          color="text.100"
                        >
                          {item.label} :{" "}
                        </Text>
                        <Text as="span" variant={TextVariant} color="text.100">
                          {item.text}
                        </Text>
                      </Box>
                    </HStack>
                  ))}
              </Stack>
            </Stack>
          </Center>
          <Center>
            <Box
              h={{ base: "250px", md: "350px", lg: "100%" }}
              w={{ base: "100%", md: "500px", xl: "600px" }}
              position="relative"
              alignSelf={"center"}
            >
              <Image
                src={visionImg}
                alt="about"
                fill
                style={{
                  borderRadius: "12px",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
                loading="lazy"
              />
            </Box>
          </Center>
        </Flex>
        <Flex
          direction={{ base: "column", md: "row" }}
          gap={{ base: 2, md: 20 }}
          borderRadius={"12px"}
          backgroundColor={"gray.100"}
        >
          <Center>
            <Box
              h={{ base: "250px", md: "350px", lg: "100%" }}
              w={{ base: "100%", md: "500px", xl: "600px" }}
              position="relative"
              alignSelf={"center"}
            >
              <Image
                src={missionImg}
                alt="about"
                layout="fill"
                objectFit="cover"
                objectPosition="center"
                style={{ borderRadius: "12px" }}
              />
            </Box>
          </Center>
          <Center flex={1.25} p={{ base: 4, md: 8 }}>
            <Stack gap={4} mt={2}>
              <Text variant={"label1"} fontWeight={600}>
                {Comp2.title}
              </Text>
              {Comp2.desc.map((item, descIndex) => (
                <Text key={descIndex} variant={TextVariant} color="text.100">
                  <Highlight
                    styles={{ fontWeight: 700, color: "text.100" }}
                    query={item.highlight}
                  >
                    {item.text}
                  </Highlight>
                </Text>
              ))}
              <Stack gap={1}>
                {Comp2.list &&
                  Comp2.list.map((item, listIndex) => (
                    <Box key={listIndex}>
                      <Text
                        as="span"
                        variant={TextVariant}
                        fontWeight="600"
                        color="text.100"
                      >
                        {item.label} :{" "}
                      </Text>
                      <Text as="span" variant={TextVariant} color="text.100">
                        {item.text}
                      </Text>
                    </Box>
                  ))}
              </Stack>
            </Stack>
          </Center>
        </Flex>
      </Flex>
    </Box>
  );
};

export default VisionComp;
